import {BehaviorSubject, of} from 'rxjs';
import {filter, startWith, switchMap} from 'rxjs/operators';
import {mc} from '@px/helper/mc';
import {userApi} from '@px/api/user';
import {authStatus$} from './auth';

// 反向合约浮盈加仓灰度
export const coinMarginedContractGray$ = new BehaviorSubject<Boolean>(true);

export const accountGray$ = authStatus$.pipe(
  filter((status) => status !== 'Init'),
  switchMap((status) => {
    if (status === 'Logout') {
      return of(createAccountGray());
    }
    return loadGray();
  }),
  startWith(null)
);

async function loadGray(): Promise<AccountGray> {
  const {data, error} = await userApi.getUserBizGray();
  if (error) {
    mc.send('toast', 'error', error);
  }
  if (data) {
    return data;
  }
  return createAccountGray();
}

function createAccountGray(): AccountGray {
  return {
    ptMining: false,
    sbt: false,
    pt: false,
    lendingAccount: false,
    spotUta: false,
    ptSpotFeeDeduct: false,
    ptContractFeeDeduct: false,
    lending: false,
    ethCoinMarginedContract: false,
    btcCoinMarginedContract: false,
  };
}
